module.exports = __webpack_public_path__ + "static/media/elogo.ed0315e3.png";